import { useRoute, useRouter } from 'vue-router';
import { useBasketStore } from '@/pinia/basket';

export async function basketValidate({ callback, backRedirect = false, newContractId, router = useRouter(), route = useRoute() }) {
  // const basketStore = useBasketStore()
  // if (basketStore.basketQty > 0 && basketStore.contractIdentifier.contractId != newContractId) {
  //   const admin_sentence = window.VITE_APP_INSTALLATION_TYPE === 'business' 
  //     && basketStore.customerId !== route.params.customerId ? ' for a different customer' : ''
  //   const contractType = basketStore.contractIdentifier?.contractType?.toLowerCase() || 'contract'
  //   const url = window.VITE_APP_INSTALLATION_TYPE === 'business' ? `/customer/${basketStore.customerId}/sales-dashboard` : ''
  //   window.alertBox.fire({
  //     title: `You have an unsaved ${contractType} in the basket` + admin_sentence,
  //     showCancelButton: false,
  //     showConfirmButton: false,
  //     html: 
  //     `<div class="mb-5">Clicking continue will override the ${contractType} in the basket.</div>
  //     <button id="validate-back" class="btn m-1">Go Back</button>
  //     <button id="validate-basket" class="btn btn-action m-1">Open Basket</button>
  //     <button id="validate-continue" class="btn btn-action m-1">Continue</button>`,
  //     didOpen: async () => {
  //       document.getElementById('validate-back').addEventListener('click', () => {
  //         window.alertBox.close();
  //         if (backRedirect) {
  //           router.go(-1);
  //         }
  //       });
  //       document.getElementById('validate-basket').addEventListener('click', async () => {
  //         await window.touch.processingReloadContract(basketStore.customerId, basketStore.contractIdentifier.contractId);
  //         router.replace(`${url}/basket`)
  //         window.alertBox.close();
  //       });
  //       document.getElementById('validate-continue').addEventListener('click', async () => {
  //         window.alertBox.close();
  //         await callback()
  //       });
  //     },
  //   });
  // } else {
  //   await callback()
  // }
  await callback()
}
